import { useQuery } from '@tanstack/react-query';
import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';
import { fetchVisioRoomId } from '@/lib/visio/room-lookup';

/**
 * Salle vidéo d'un rendez-vous (une salle par CRÉNEAU depuis la migration 0255 —
 * `fetchVisioRoomId` passe par le créneau, jamais par `reservation_id` seul).
 * `null` = la salle n'a jamais été ouverte : aucun fichier de réunion possible.
 */
export function useRendezVousRoomId(reservationId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ['rendezvous-room-id', reservationId],
    enabled: !!reservationId && enabled,
    staleTime: 60_000,
    queryFn: () => fetchVisioRoomId(supabase as unknown as SupabaseClient, reservationId as string),
  });
}
